import type { ComponentType, JSX } from 'react';

import { IndexPage } from '@/pages/IndexPage/IndexPage';
import { CoursesPage } from '@/pages/CoursesPage/CoursesPage';
import { CoursePage } from '@/pages/CoursePage/CoursePage';
import { CourseLandingPage } from '@/pages/CoursePage/CourseLandingPage';
import { CourseContentsPage } from '@/pages/CoursePage/CourseContentsPage';

interface Route {
  path: string;
  Component: ComponentType;
  title?: string;
  icon?: JSX.Element;
}

export const routes: Route[] = [
  { path: '/', Component: IndexPage },
  { path: '/courses', Component: CoursesPage, title: 'Courses' },
  { path: '/course/:courseId', Component: CoursePage, title: 'Course' },
  { path: '/course/:courseId/landing', Component: CourseLandingPage, title: 'Course Details' },
  { path: '/course/:courseId/contents', Component: CourseContentsPage, title: 'Course Contents' },
];
